import { usePasteConfig } from '@/components/custom/erp';

interface UseDetailPasteProps {
  columns: any[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<any[]>; resultField?: string }>
  ) => void;
}

export const useDetailPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseDetailPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
